import { useEffect, useState } from 'react'
import Modal from 'react-modal'
import { useDispatch, useSelector } from 'react-redux'
import errorAlert from '../../assets/images/error-alert.svg'
import { ETR_STATUS } from '../../constants'
import { DisplayStatusName } from '../../helpers/texthelper'
import { CancelModalModel, CancelModalProps } from '../../models/component'
import * as documentAction from '../../redux/actions/document.detail.action'
import { RootReducers } from '../../redux/reducers'
import { LoadingOverlay } from '../loadingOverlay'

const initialState: CancelModalModel = {
  eTRNo: '',
  id: 0,
  reasonText: ''
}
export const CancelModal: React.VFC<CancelModalProps> = ({
  data,
  handleOkButton,
  handleCancelbutton,
  isOpenModal
}) => {
  const dispatch = useDispatch()
  const documentData = useSelector((state: RootReducers) => state.documentDetailReducer)
  const isFetching = useSelector((state: RootReducers) => state.documentDetailReducer.isFetching)
  const [reasonText, setReasonText] = useState('')
  const [textRequire, setTextRequire] = useState<string>('')
  const isDisable = documentData.documentModel?.status !== ETR_STATUS.NEW_ETR

  useEffect(() => {
    console.log(`cancel ${data.id}`)
    if (data.id && isOpenModal) {
      dispatch(documentAction.handleGetDocumentById(String(data.id)))
    }
  }, [data, isOpenModal])

  const handleTextCancel = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value: text } = event.target

    setReasonText(text)
    data.reasonText = text
    setTextRequire('')
  }
  const handleOkButtonClick = () => {
    if (reasonText.length > 0) {
      console.log(reasonText)
      setTextRequire('')
      handleOkButton(data)
    } else {
      setTextRequire('กรุณาระบุเหตุผลในการยกเลิก')
    }
  }

  return (
    <div>
      <Modal
        isOpen={isOpenModal}
        onAfterClose={() => {
          data.reasonText = ''
          setTextRequire('')
          setReasonText('')
        }}
        className="modal-cancel"
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(24, 48, 40, 0.9)'
          }
        }}
        ariaHideApp={false}
      >
        {isFetching && <LoadingOverlay />}
        <div className="modal-cancel-content">
          <div>
            <div className="modal-cancel-header-text">ยืนยันยกเลิกใบรับเงินชั่วคราว</div>
            <div style={{ marginBottom: 85, display: 'flex', flexDirection: 'column', gap: 10 }}>
              <select
                className="field-input"
                data-testid="field-input"
                style={(textRequire && { border: '1px solid #b30909' }) || {}}
                onChange={e => handleTextCancel(e)}
              >
                <option value="">กรุณาระบุเหตุผลในการยกเลิก</option>
                <option key="C001" value="ข้อมูลบัตรเครดิตไม่ถูกต้อง">
                  ข้อมูลบัตรเครดิตไม่ถูกต้อง
                </option>
                <option key="C002" value="เจ้าของบัตรเครดิตไม่มีความสัมพันธ์กับผู้เอาประกัน">
                  เจ้าของบัตรเครดิตไม่มีความสัมพันธ์กับผู้เอาประกัน
                </option>
                <option
                  key="C003"
                  value="ผลการตัดบัตรเครดิตไม่สำเร็จ - กรุณาติดต่อธนาคารเจ้าของบัตรเครดิต"
                >
                  ผลการตัดบัตรเครดิตไม่สำเร็จ - กรุณาติดต่อธนาคารเจ้าของบัตรเครดิต
                </option>
                <option
                  key="C004"
                  value="ผลการตัดบัตรเครดิตไม่สำเร็จ เนื่องจากวันหมดอายุของบัตรเครดิตไม่ถูกต้อง"
                >
                  ผลการตัดบัตรเครดิตไม่สำเร็จ เนื่องจากวันหมดอายุของบัตรเครดิตไม่ถูกต้อง
                </option>
                <option key="C005" value="ผู้เอาประกันขอยกเลิกรายการชำระเงิน">
                  ผู้เอาประกันขอยกเลิกรายการชำระเงิน
                </option>
                <option key="C006" value="ผู้เอาประกันเปลี่ยนช่องทางการชำระด้วยวิธีอื่น">
                  ผู้เอาประกันเปลี่ยนช่องทางการชำระด้วยวิธีอื่น
                </option>
                <option key="C007" value="ระบุข้อมูลผิด/ไม่ครบถ้วน">
                  ระบุข้อมูลผิด/ไม่ครบถ้วน
                </option>
                <option key="C008" value="อื่น ๆ กรุณาสอบถามเพิ่มเติมได้ที่ตัวแทน">
                  อื่น ๆ กรุณาสอบถามเพิ่มเติมได้ที่ตัวแทน
                </option>
              </select>
              {/* <textarea
                style={(textRequire && { border: '1px solid #b30909' }) || {}}
                placeholder="กรุณาระบุเหตุผลในการยกเลิก"
                //value={textCancel}
                onChange={e => handleTextCancel(e)}
              /> */}
              {textRequire && (
                <div className="error-text-validate">
                  <img src={errorAlert} alt="ErrorAlert" />
                  {textRequire}
                </div>
              )}
              {!isFetching && isDisable && (
                <div className="error-text-validate">
                  <img src={errorAlert} alt="ErrorAlert" />
                  {`ไม่สามารถทำรายการได้เนื่องจากรายการนี้ได้ถูกดำเนินการปรับสถานะเป็น "${DisplayStatusName(
                    documentData.documentModel?.status
                  )}" แล้ว`}
                </div>
              )}
            </div>
          </div>
          <div className="modal-cancel-group-button">
            <button className="cancel-transaction-button" onClick={() => handleCancelbutton()}>
              ยกเลิก
            </button>
            <button
              className="confirm-transaction-button"
              onClick={() => handleOkButtonClick()}
              disabled={isDisable}
            >
              ยืนยัน
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}
